import { createRouter, createWebHistory } from 'vue-router';
import {central_data} from '@/lib/vendor/eve/central-data';

const routes = [
    //<editor-fold defaultstate="collapsed" desc="mod-login">
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "mod-login" */ '@/components/login')
    },
    //</editor-fold>
    //<editor-fold defaultstate="collapsed" desc="mod-user">    
    {
        path: '/user-list',
        name: 'user.list',
        component: () => import(/* webpackChunkName: "mod-user" */ '@/components/user-list'),
        children: [
            {
                path: 'add',
                name: 'user.add',
                component: () => import(/* webpackChunkName: "mod-user" */ '@/components/user-edit')
            },
            {
                path: 'edit/:userid',
                name: 'user.edit',
                props: true,
                component: () => import(/* webpackChunkName: "mod-user" */ '@/components/user-edit')
            }
        ]
    },
    //</editor-fold>
    //<editor-fold defaultstate="collapsed" desc="mod-region">    
    {
        path: '/region-list',
        name: 'region.list',
        component: () => import(/* webpackChunkName: "mod-region" */ '@/components/region-list'),
        children: [
            {
                path: 'add',
                name: 'region.add',
                component: () => import(/* webpackChunkName: "mod-region" */ '@/components/region-edit')
            },
            {
                path: 'edit/:regionid',
                name: 'region.edit',
                props: true,
                component: () => import(/* webpackChunkName: "mod-region" */ '@/components/region-edit')
            }
        ]
    },
    //</editor-fold>
    //<editor-fold defaultstate="collapsed" desc="mod-set-of-*"> 
    //<editor-fold defaultstate="collapsed" desc="mod-set-of-field"> 
    {
        path: '/set-of-field',
        name: 'set-of-field.list',
        component: () => import(/* webpackChunkName: "mod-set-of-field" */ '@/components/set/set-of-field-list')
        , children: [
            {
                path: 'add',
                name: 'set-of-field.add',
                component: () => import(/* webpackChunkName: "mod-set-of-field" */ '@/components/set/set-of-field')
            },
            {
                path: 'edit/:setid',
                name: 'set-of-field.edit',
                props: true,
                component: () => import(/* webpackChunkName: "mod-set-of-field" */ '@/components/set/set-of-field')
            }
        ]
    },
    //</editor-fold>
    //<editor-fold defaultstate="collapsed" desc="mod-set-of-criteria"> 
    {
        path: '/set-of-criteria',
        name: 'set-of-criteria.list',
        component: () => import(/* webpackChunkName: "mod-set-of-criteria" */ '@/components/set/set-of-criteria-list')
        , children: [
            {
                path: 'add',
                name: 'set-of-criteria.add',
                component: () => import(/* webpackChunkName: "mod-set-of-criteria" */ '@/components/set/set-of-criteria')
            },
            {
                path: 'edit/:setid',
                name: 'set-of-criteria.edit',
                props: true,
                component: () => import(/* webpackChunkName: "mod-set-of-criteria" */ '@/components/set/set-of-criteria')
            }
        ]
    },
    //</editor-fold>
    //<editor-fold defaultstate="collapsed" desc="mod-set-of-outlay"> 
    {
        path: '/set-of-outlay',
        name: 'set-of-outlay.list',
        component: () => import(/* webpackChunkName: "mod-set-of-outlay" */ '@/components/set/set-of-outlay-list')
        , children: [
            {
                path: 'add',
                name: 'set-of-outlay.add',
                component: () => import(/* webpackChunkName: "mod-set-of-outlay" */ '@/components/set/set-of-outlay')
            },
            {
                path: 'edit/:setid',
                name: 'set-of-outlay.edit',
                props: true,
                component: () => import(/* webpackChunkName: "mod-set-of-outlay" */ '@/components/set/set-of-outlay')
            }
        ]
    },
    //</editor-fold>
    //<editor-fold defaultstate="collapsed" desc="mod-set-of-calendar"> 
    {
        path: '/set-of-calendar',
        name: 'set-of-calendar.list',
        component: () => import(/* webpackChunkName: "mod-set-of-calendar" */ '@/components/set/set-of-calendar-list')
        , children: [
            {
                path: 'add',
                name: 'set-of-calendar.add',
                component: () => import(/* webpackChunkName: "mod-set-of-calendar" */ '@/components/set/set-of-calendar')
            },
            {
                path: 'edit/:setid',
                name: 'set-of-calendar.edit',
                props: true,
                component: () => import(/* webpackChunkName: "mod-set-of-calendar" */ '@/components/set/set-of-calendar')
            }
        ]
    },
    //</editor-fold>
    //<editor-fold defaultstate="collapsed" desc="mod-set-of-document"> 
    {
        path: '/set-of-document',
        name: 'set-of-document.list',
        component: () => import(/* webpackChunkName: "mod-set-of-document" */ '@/components/set/set-of-document-list')
        , children: [
            {
                path: 'add',
                name: 'set-of-document.add',
                component: () => import(/* webpackChunkName: "mod-set-of-document" */ '@/components/set/set-of-document')
            },
            {
                path: 'edit/:setid',
                name: 'set-of-document.edit',
                props: true,
                component: () => import(/* webpackChunkName: "mod-set-of-document" */ '@/components/set/set-of-document')
            }
        ]
    },
    //</editor-fold>
    //</editor-fold>
    //<editor-fold defaultstate="collapsed" desc="mod-client">    
    {
        path: '/client-list',
        name: 'client.list',

        component: () => import(/* webpackChunkName: "mod-client" */ '@/components/client-list')
        , children: [
            {
                path: 'edit/:clientid',
                name: 'client.edit',
                props: true,
                component: () => import(/* webpackChunkName: "mod-client" */ '@/components/client-edit')
            }
        ]
    },
    //</editor-fold>
    //<editor-fold defaultstate="collapsed" desc="mod-document">   

    {
        path: '/var-list',
        name: 'var.list',
        component: () => import(/* webpackChunkName: "mod-help" */ '@/components/mod-help/docx-help')
        //component: () => import(/* webpackChunkName: "mod-document" */ '@/components/var-list')
    },
    //</editor-fold>
    //<editor-fold defaultstate="collapsed" desc="mod-grant">    
    {
        path: '/grant-list',
        name: 'grant.list',
        component: () => import(/* webpackChunkName: "mod-grant" */ '@/components/grant-list')
        , children: [
            {
                path: 'add',
                name: 'grant.add',
                component: () => import(/* webpackChunkName: "mod-grant" */ '@/components/grant-edit/grant-edit-main')
            },
            {
                path: 'edit/:grantid',
                name: 'grant.edit',
                props: true,
                component: () => import(/* webpackChunkName: "mod-grant" */ '@/components/grant-edit/grant-edit-main')
            }
        ]
    },

    //</editor-fold>
    //<editor-fold defaultstate="collapsed" desc="mod-claim">
    {
        path: '/claim-list/:grantId',
        name: 'claim.list',
        props: true,
        component: () => import(/* webpackChunkName: "mod-claim" */ '@/components/claim-list')
        , children: [
            {
                path: 'edit/:claimid',
                name: 'claim.edit',
                props: true,
                component: () => import(/* webpackChunkName: "mod-claim" */ '@/components/claim-edit/claim-edit')
            }
        ]
    },
    //</editor-fold>
    //<editor-fold defaultstate="collapsed" desc="mod-preferences">    
    {
        path: '/preferences',
        name: 'preferences.list',
        component: () => import(/* webpackChunkName: "mod-preferences" */ '@/components/preferences')
    },
    //</editor-fold>
    //<editor-fold defaultstate="collapsed" desc="mod-yd-token">    
    {
        path: '/ytoken-list',
        name: 'ytoken.list',
        component: () => import(/* webpackChunkName: "mod-ytoken" */ '@/components/yd-token-list')
        , children: [
            {
                path: 'add',
                name: 'ytoken.add',
                component: () => import(/* webpackChunkName: "mod-ytoken" */ '@/components/yd-token-edit')
            },
            {
                path: 'edit/:tokenid',
                name: 'ytoken.edit',
                props: true,
                component: () => import(/* webpackChunkName: "mod-ytoken" */ '@/components/yd-token-edit')
            }
        ]
    },
    {
        path: '/yocrc9d63fcfd55b4c028fe67c700ab1b033',
        component: () => import(/* webpackChunkName: "mod-ytoken" */ '@/components/yd-token-receiver')
    },

    //</editor-fold>
    //<editor-fold defaultstate="collapsed" desc="mod-help">    
    {
        path: '/help-docx',
        name: 'help.docx',
        component: () => import(/* webpackChunkName: "mod-help" */ '@/components/mod-help/docx-help')
    },

    //</editor-fold>


    {
        path: '/',
        name: 'home',
        component: () => {
            return import('@/components/user-list');
        },
        props: true
    }
];
var route_id = 0;
const named_routes = routes.map(function (x) {
    if (!x.name) {
        x.name = ["rt", route_id].join('');
        route_id++;
    }
    return x;
});

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: named_routes
});
router.beforeResolve(function (a, b, c) {
    //console.log(arguments);
    c();
});


function reloadRoutes() {
    for (var iRoute = 0; iRoute < named_routes.length; iRoute++) {
        router.removeRoute(named_routes[iRoute].name);
    }
    for (var aRoute = 0; aRoute < named_routes.length; aRoute++) {
        router.addRoute(named_routes[aRoute]);
    }
    console.log('routes reloaded');
    //router.go();
    //console.log('force reload');
}

central_data().ready(function () {
    window.xxrouter = router;
    central_data().jwtMonitor.on({}, reloadRoutes);


});

export default router
